var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.122,
    height: 32,
    viewBox: "0 0 34.122 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 34.122,
    height: 32,
    transform: "translate(-2)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5553",
    "data-name": "Rectangle 5553",
    width: 29.025,
    height: 30.018,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28570",
    "data-name": "Group 28570",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35611",
    "data-name": "Group 35611",
    transform: "translate(0.561 1.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35611-2",
    "data-name": "Group 35611",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39522",
    "data-name": "Path 39522",
    d: "M.845,14.9a.766.766,0,0,1-.219-.032.755.755,0,0,1-.519-.877,4.1,4.1,0,0,1,.549-1.361.754.754,0,0,1,1.336.686l-.447,1.111a.755.755,0,0,1-.7.473",
    transform: "translate(-0.022 -3.017)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39523",
    "data-name": "Path 39523",
    d: "M5.276,20.732a1.645,1.645,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-1.082 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39524",
    "data-name": "Path 39524",
    d: "M14.394,20.732a1.652,1.652,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-3.323 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39525",
    "data-name": "Path 39525",
    d: "M23.513,20.732a1.659,1.659,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.652,1.652,0,0,1-.22.012",
    transform: "translate(-5.564 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39526",
    "data-name": "Path 39526",
    d: "M32.632,20.732a1.652,1.652,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-7.805 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39527",
    "data-name": "Path 39527",
    d: "M26.825,34.74H2.512a.755.755,0,0,1-.754-.754V30.734a.754.754,0,1,1,1.509,0v2.5h22.8V19.971a.754.754,0,1,1,1.509,0V33.986a.755.755,0,0,1-.754.754",
    transform: "translate(-0.432 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39528",
    "data-name": "Path 39528",
    d: "M2.512,27.451a.755.755,0,0,1-.754-.754V19.971a.754.754,0,1,1,1.509,0V26.7a.755.755,0,0,1-.754.754",
    transform: "translate(-0.432 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39529",
    "data-name": "Path 39529",
    d: "M23.068,35.836H10.6a.755.755,0,0,1-.754-.754V24.43a.755.755,0,0,1,.754-.754H23.068a.755.755,0,0,1,.754.754V35.082a.755.755,0,0,1-.754.754M11.352,34.328H22.314V25.185H11.352Z",
    transform: "translate(-2.419 -5.818)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39530",
    "data-name": "Path 39530",
    d: "M18.8,35.836a.755.755,0,0,1-.754-.754V24.43a.754.754,0,0,1,1.509,0V35.082a.755.755,0,0,1-.754.754",
    transform: "translate(-4.435 -5.818)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39531",
    "data-name": "Path 39531",
    d: "M24.71,16a4.193,4.193,0,0,1-3.321-1.777A4.168,4.168,0,0,1,18.089,16h-.257a4.192,4.192,0,0,1-3.322-1.778A4.166,4.166,0,0,1,11.211,16h-.257a4.192,4.192,0,0,1-3.322-1.778A4.168,4.168,0,0,1,4.334,16H4.076A4.173,4.173,0,0,1,0,11.816a4.442,4.442,0,0,1,.081-.832.811.811,0,0,1,.041-.14L4.307.473A.754.754,0,0,1,5.006,0H23.488a.754.754,0,0,1,.687.444l4.731,10.483a.761.761,0,0,1,.052.161,3.715,3.715,0,0,1,.068.727A4.172,4.172,0,0,1,24.967,16Zm-2.567-4.188a2.667,2.667,0,0,0,2.592,2.68h.21a2.665,2.665,0,0,0,2.574-2.679,2.274,2.274,0,0,0-.026-.355L23,1.51H5.515L1.552,11.335a2.812,2.812,0,0,0-.043.481A2.667,2.667,0,0,0,4.1,14.5h.21a2.662,2.662,0,0,0,2.567-2.679.754.754,0,1,1,1.509,0,2.667,2.667,0,0,0,2.592,2.68h.21a2.662,2.662,0,0,0,2.567-2.679.754.754,0,1,1,1.509,0,2.668,2.668,0,0,0,2.592,2.68h.21a2.662,2.662,0,0,0,2.567-2.679.754.754,0,1,1,1.509,0",
    transform: "translate(0 0)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39532",
    "data-name": "Path 39532",
    d: "M5.276,20.732a1.645,1.645,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-1.082 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39533",
    "data-name": "Path 39533",
    d: "M14.394,20.732a1.652,1.652,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-3.323 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39534",
    "data-name": "Path 39534",
    d: "M23.513,20.732a1.659,1.659,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.652,1.652,0,0,1-.22.012",
    transform: "translate(-5.564 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39535",
    "data-name": "Path 39535",
    d: "M32.632,20.732a1.652,1.652,0,0,1-.22-.012.754.754,0,0,1,.1-1.5h.234a.754.754,0,0,1,.1,1.5,1.659,1.659,0,0,1-.22.012",
    transform: "translate(-7.805 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39536",
    "data-name": "Path 39536",
    d: "M26.825,34.74H2.512a.755.755,0,0,1-.754-.754V30.734a.754.754,0,1,1,1.509,0v2.5h22.8V19.971a.754.754,0,1,1,1.509,0V33.986a.755.755,0,0,1-.754.754",
    transform: "translate(-0.432 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39537",
    "data-name": "Path 39537",
    d: "M2.512,27.451a.755.755,0,0,1-.754-.754V19.971a.754.754,0,1,1,1.509,0V26.7a.755.755,0,0,1-.754.754",
    transform: "translate(-0.432 -4.723)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39538",
    "data-name": "Path 39538",
    d: "M23.068,35.836H10.6a.755.755,0,0,1-.754-.754V24.43a.755.755,0,0,1,.754-.754H23.068a.755.755,0,0,1,.754.754V35.082a.755.755,0,0,1-.754.754M11.352,34.328H22.314V25.185H11.352Z",
    transform: "translate(-2.419 -5.818)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39539",
    "data-name": "Path 39539",
    d: "M18.8,35.836a.755.755,0,0,1-.754-.754V24.43a.754.754,0,0,1,1.509,0V35.082a.755.755,0,0,1-.754.754",
    transform: "translate(-4.435 -5.818)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39540",
    "data-name": "Path 39540",
    d: "M24.71,16a4.192,4.192,0,0,1-3.321-1.777A4.17,4.17,0,0,1,18.09,16h-.258a4.191,4.191,0,0,1-3.321-1.778A4.168,4.168,0,0,1,11.212,16h-.258a4.191,4.191,0,0,1-3.321-1.778A4.17,4.17,0,0,1,4.334,16H4.077A4.174,4.174,0,0,1,0,11.816a.754.754,0,1,1,1.509,0A2.667,2.667,0,0,0,4.1,14.5h.21a2.662,2.662,0,0,0,2.567-2.679.754.754,0,0,1,1.509,0A2.667,2.667,0,0,0,10.978,14.5h.21a2.663,2.663,0,0,0,2.568-2.679.754.754,0,1,1,1.509,0A2.667,2.667,0,0,0,17.856,14.5h.21a2.663,2.663,0,0,0,2.568-2.679.754.754,0,1,1,1.509,0A2.667,2.667,0,0,0,24.734,14.5h.21a2.665,2.665,0,0,0,2.574-2.679,2.362,2.362,0,0,0-.026-.355L22.8,1.065A.754.754,0,0,1,24.176.444l4.731,10.483a.712.712,0,0,1,.051.161,3.721,3.721,0,0,1,.069.728A4.173,4.173,0,0,1,24.968,16Z",
    transform: "translate(0 0)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39541",
    "data-name": "Path 39541",
    d: "M1.437,10.768a.745.745,0,0,1-.282-.055.755.755,0,0,1-.417-.982L4.475.473a.754.754,0,1,1,1.4.564L2.137,10.3a.755.755,0,0,1-.7.472",
    transform: "translate(-0.168 0)",
    fill: "#fc3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.ca73e59ae84bd4701a0c9f8db4829d0a.svg";
export { ForwardRef as ReactComponent };